'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiUserDelete = function TiUserDelete(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 23.3h-10c-0.9 0-1.7-0.7-1.7-1.6s0.8-1.7 1.7-1.7h10c0.9 0 1.7 0.7 1.7 1.7s-0.8 1.6-1.7 1.6z m-11.7-8.3c0 2.3-0.9 4.4-2.4 5.9-1.5 1.5-3.6 2.4-5.9 2.4s-4.4-0.9-5.9-2.4c-1.5-1.5-2.4-3.6-2.4-5.9s0.9-4.4 2.4-5.9c1.5-1.5 3.6-2.4 5.9-2.4s4.4 0.9 5.9 2.4c1.5 1.5 2.4 3.6 2.4 5.9z m-8.3 10c-6.2 0-10 3.3-10 6.7 0 1.6 3.8 3.3 10 3.3 5.9 0 10-1.7 10-3.3s-3.9-6.7-10-6.7z' })
        )
    );
};

exports.default = TiUserDelete;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/user-delete.js
// module id = 2241
// module chunks = 0